import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { CurrencyField } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { isNotBlank } from '@roc/feature-utils';

interface HudFormContentProps {
  open: boolean;
}

export const HudFormContent = observer(({ open }: HudFormContentProps) => {
  const { docReviewStoreV2 } = useStore();
  const { hudFormStore } = docReviewStoreV2;

  useEffect(() => {
    if (open) hudFormStore.load(docReviewStoreV2.docReviewData);
  }, [open]);

  const handleChange = (field: string, value: any) => {
    hudFormStore.onFieldChange(field, value);
  };

  const f = hudFormStore.form.fields;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CurrencyField
          label="Borrower Cash Out at Close"
          value={f.borrowerCashAtClosing.value}
          onChange={(_name, value) => handleChange('borrowerCashAtClosing', value)}
          name="borrowerCashAtClosing"
          testId="borrowerCashAtClosing"
          variant="outlined"
          fullWidth
          standaloneLabel
          required
          allowNegative
          error={isNotBlank(f.borrowerCashAtClosing.error)}
          errorText={f.borrowerCashAtClosing.error}
        />
      </Grid>
    </Grid>
  );
});
